<template>
  <div>
    <div class="bg-white p-4" style="border: solid 1px #eaeaea">
      <ValidationObserver tag="form" ref="form" @submit.stop.prevent="savePart" v-slot="{ invalid }" class="">
        <div class="row">
          <div class="col-6">
            <ValidationProvider name="OrderStatus" rules="" v-slot="{}">
              <div class="label mt-2">Order status</div>
              <select class="form-control" v-model="vendorRequestPart.orderStatusId">
                <option v-for="status in orderStatus" :value="status.id" :key="status.id">{{ status.name }}</option>
              </select>
            </ValidationProvider>
          </div>

          <div class="col-6">
            <ValidationProvider name="Quantity" rules="" v-slot="{ errors }">
              <div class="label mt-2">Quantity Ordered</div>
              <input
                type="number"
                class="form-control"
                placeholder="Quantity ordered"
                :class="{ 'is-invalid': errors[0] }"
                v-model="vendorRequestPart.quantityOrdered"
              />
            </ValidationProvider>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <ValidationProvider name="AmosOrderNo" rules="" v-slot="{ errors }">
              <div class="label mt-2">Amos Order #
              <span v-if="vendorRequestPart.amosOrderNo"><a :href="'amos://order.' + vendorRequestPart.amosOrderNo" target="_blank">(Link)</a></span>
              </div>
              <input
                type="text"
                class="form-control"
                placeholder="Amos order number"
                :class="{ 'is-invalid': errors[0] }"
                v-model="vendorRequestPart.amosOrderNo"
              />
            </ValidationProvider>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="label mt-2">PACKAGE DIMENSIONS (L x W x H) AND WEIGHT</div>
            <div class="d-flex justify-content-between align-items-center">
              <input type="number" class="form-control max-w-20" v-model="vendorRequestPart.packageLength" placeholder="Length" />
              <div class="label-xl ml-2 mr-2 text-nowrap">cm x</div>
              <input type="number" class="form-control" v-model="vendorRequestPart.packageWidth" placeholder="Width" />
              <div class="label-xl ml-2 mr-2 text-nowrap">cm x</div>
              <input type="number" class="form-control" v-model="vendorRequestPart.packageHeight" placeholder="Height" />
              <div class="label-xl ml-2 mr-2 text-nowrap">cm</div>
              <input type="number" class="form-control" v-model="vendorRequestPart.packageWeight" placeholder="Weight" />
              <div class="label-xl ml-2 mr-2">kg</div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <ValidationProvider name="AmosOrderNo" rules="" v-slot="{ errors }">
              <div class="label mt-2">Remarks</div>
              <textarea
                  class="form-control"
                  placeholder="Remarks"
                  :class="{ 'is-invalid': errors[0] }"
                  v-model="vendorRequestPart.remarks"
              />
            </ValidationProvider>
          </div>
        </div>

        <hr class="mt-3 mb-2" />

        <div class="row">
          <div :class="{'col-6': !shipperIsOther, 'col-4': shipperIsOther}">
            <div class="label mt-2">
              Shipping via
              <span v-if="vendorRequestPart.shipperPopupConfirmationTlc">
                (confirmed by {{ vendorRequestPart.shipperPopupConfirmationTlc }})
              </span>
            </div>
            <select class="form-control" v-model="vendorRequestPart.shipperId" @change="changeShipper" placeholder="Please select...">
              <option :value="null" selected disabled>Please select</option>
              <option v-for="s in shipper" :key="s.id" :value="s.id">{{ s.name }}</option>
            </select>


          </div>

          <div class="col-4" v-if="shipperIsOther">
            <div class="label mt-2">
              Shipper remark

            </div>
            <input
                type="text"
                class="form-control"
                placeholder="Shipper remark"
                v-model="vendorRequestPart.shipperFreetext"
            />
          </div>

          <div :class="{'col-6': !shipperIsOther, 'col-4': shipperIsOther}">
            <div class="label mt-2">Shipping Status</div>
            <select class="form-control" v-model="vendorRequestPart.shipmentStatusId">
              <option v-for="s in shipmentStatus" :key="s.id" :value="s.id">{{ s.name }}</option>
            </select>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <ValidationProvider name="ETA" rules="" v-slot="{}">
              <div class="label mt-2">ETA</div>
              <board-item-date-picker v-model="vendorRequestPart.estimatedTimeOfArrival"></board-item-date-picker>
            </ValidationProvider>
          </div>

          <div class="col-6">
            <ValidationProvider name="ATA" rules="" v-slot="{}">
              <div class="label mt-2">ATA</div>
              <board-item-date-picker v-model="vendorRequestPart.actualTimeOfArrival"></board-item-date-picker>
            </ValidationProvider>
          </div>
        </div>

        <hr class="mt-3 mb-2" />

        <div class="mt-3 d-flex justify-content-between align-content-center">
          <div class="so-btn">
            <button type="button" class="btn btn-block btn-sm btn-secondary" @click="close()">
              <i class="far fa-times"></i>
              Close
            </button>
          </div>
          <div class="so-btn">
            <button type="submit" class="btn btn-block btn-sm btn-success" :disabled="invalid">
              <i class="far fa-save"></i>
              Save and close
            </button>
          </div>
        </div>
      </ValidationObserver>
    </div>

    <b-modal ref="shipperModal" id="shipperModal" hide-footer hide-header body-class="modal-body-wo" centered>
      <modal-window :main-width="12">
        <div class="d-block">
          <h1>
            <i class="far fa-exclamation-triangle"></i>
            Attention
          </h1>
          <p v-html="shipperPopupText"></p>
        </div>
        <hr class="mt-3" />
        <div class="mt-3 d-flex justify-content-end">
          <ValidationObserver tag="form" ref="form" @submit.stop.prevent="confirmShipperPopup" v-slot="{ invalid }" class="d-flex">
            <ValidationProvider name="ShipperConfirmation" :rules="{ required: true, is: userTlc.toUpperCase() }" v-slot="{ errors }">
              <input
                type="text"
                class="form-control"
                :placeholder="'your TLC (' + userTlc + ')'"
                :class="{ 'is-invalid': errors[0] }"
                :value="vendorRequestPart.shipperPopupConfirmationTlc ? vendorRequestPart.shipperPopupConfirmationTlc.toUpperCase(): ''"
                @input="vendorRequestPart.shipperPopupConfirmationTlc = $event.target.value.toUpperCase()"
              />
            </ValidationProvider>
            <button class="btn btn-primary btn-sm" type="submit" :disabled="invalid">Confirm</button>
          </ValidationObserver>
        </div>
      </modal-window>
    </b-modal>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { materialRequestClient } from '@/apiclient/opsboardapi';
  import { OrderStatusDto, ShipmentStatusDto, ShipperDto, VendorRequestPartOrderEditDto } from '@/apiclient/apiclient_generated';
  import { GlobalHelper } from '@/helpers/global-helper';
  import ModalWindow from '@/components/ModalWindow.vue';
  import { UserModule, UserStore } from "@/store/user";

  @Component({
    components: { ModalWindow },
  })
  export default class EditVendorRequestPartOrder extends Vue {
    materialRequestId: string;
    vendorRequestPartId: string;
    vendorRequestPart: VendorRequestPartOrderEditDto = VendorRequestPartOrderEditDto.fromJS({ part: { pn: '' } });
    shipper: ShipperDto[] = [];
    shipperPopupText = '';
    orderStatus: OrderStatusDto[] = [];
    shipmentStatus: ShipmentStatusDto[] = [];
    private userStore: UserModule = UserStore;

    shipperHasChanged = false;

    created() {
      this.materialRequestId = this.$router.currentRoute.params.materialRequestId;
      this.vendorRequestPartId = this.$router.currentRoute.params.vendorRequestPartId;
    }

    async mounted() {
      await this.loadData();
    }

    async loadData() {
      this.shipper = await materialRequestClient.getShipper();
      this.vendorRequestPart = await materialRequestClient.getVendorRequestPartOrderEditDto(this.vendorRequestPartId);
      this.orderStatus = await materialRequestClient.getOrderStatus();
      this.shipmentStatus = await materialRequestClient.getShipmentStatus();

      await this.$nextTick();
      (this.$refs.form as any).validate();
    }

    get shipperIsOther(): boolean {
      const selectedShipper = this.shipper.find((_) => _.id == this.vendorRequestPart.shipperId);
      return selectedShipper && selectedShipper.isOther;
    }

    async savePart() {
      if (this.shipperHasChanged) {
        const selectedShipper = this.shipper.find((_) => _.id == this.vendorRequestPart.shipperId);

        if (selectedShipper && selectedShipper.popupText) {
          this.shipperPopupText = selectedShipper.popupText;
          this.$bvModal.show('shipperModal');
        } else {
          this.shipperHasChanged = false;
          await this.savePart();
        }
      } else {
        try {
          await materialRequestClient.editVendorRequestPartOrder(this.vendorRequestPart);
          GlobalHelper.NotifySuccess('Part saved');
          this.$emit('saved');
        } catch {
          GlobalHelper.NotifyError('Error occured');
        }
      }
    }

    async confirmShipperPopup() {
      this.shipperHasChanged = false;
      await this.savePart();
    }

    get userTlc(): string {
      return this.userStore.user.tlc;
    }

    changeShipper() {
      this.shipperHasChanged = true;
    }

    close() {
      this.$emit('close');
    }
  }
</script>

<style lang="scss" scoped></style>
